export default __webpack_public_path__ + "static/local-video-a2a72db3f2fb91c0851e40cdac44a06a.mp4";